import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AnyAction } from 'redux';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { Reservation } from '@mews-commander/data-access';
import { trackSummaryPrinted, initializeSummary as initializeSummaryAction, openBillingAccount } from '../../actions';
import { editInternal as editInternalAction, editProfile as editProfileAction } from '../../actions/profile';
import { getCheckedReservations, getSelectedReservationServiceId } from '../../selectors';

export interface StateProps {
    reservations: Reservation[];
    selectedReservationServiceId: string;
}

export interface DispatchProps {
    onPrint(): void;
    initializeSummary(): void;
    editProfile(accountId: string): AnyAction;
    editInternal(accountId: string): AnyAction;
    billingScreen(accountId: string): AnyAction;
}

export interface OwnProps {
    scope: string;
}

export default connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        reservations: getCheckedReservations,
        selectedReservationServiceId: getSelectedReservationServiceId,
    }),
    (dispatch: CommanderThunkDispatch, { scope }) => ({
        onPrint: () => dispatch(trackSummaryPrinted()),
        initializeSummary: () => dispatch(initializeSummaryAction({ scope })),
        billingScreen: (accountId) => dispatch(openBillingAccount({ accountId })),
        editProfile: (accountId) => dispatch(editProfileAction({ accountId })),
        editInternal: (accountId) => dispatch(editInternalAction({ accountId })),
    })
);
